export default "/50f517735fec46580f19aae3e56e9fe21614ea75/ed3e1222f5d7e466f1889a4510f1de5c.svg";